<template>
  <div
    role="group"
    class="purchase-type-selector"
    :class="{ 'purchase-type-selector-disabled': !selectedVariant }"
  >
    <div key="one-time" class="purchase-type-selector-option">
      <span
        class="purchase-type-selector-radio-input"
        :class="{ disabled: !selectedVariant }"
      >
        <span
          class="purchase-type-selector-radio-control"
          :class="{
            active: purchaseType === RECHARGE_PURCHASE_TYPES.ONE_TIME,
            disabled: !selectedVariant
          }"
          @click="onClick(RECHARGE_PURCHASE_TYPES.ONE_TIME)"
        />
        <input
          id="option-one-time"
          tabindex="-1"
          type="radio"
          value="one-time"
          name="one-time"
          :disabled="!selectedVariant"
          :checked="purchaseType === RECHARGE_PURCHASE_TYPES.ONE_TIME"
          @click="onClick(RECHARGE_PURCHASE_TYPES.ONE_TIME)"
        />
      </span>
      <label tabindex="0" for="option-one-time">
        {{ translations.oneTimePurchaseText }}
      </label>
    </div>
    <div key="subscription" class="purchase-type-selector-option">
      <span
        class="purchase-type-selector-radio-input"
        :class="{ disabled: !selectedVariant }"
      >
        <span
          class="purchase-type-selector-radio-control"
          :class="{
            active: purchaseType === RECHARGE_PURCHASE_TYPES.SUBSCRIPTION,
            disabled: !selectedVariant
          }"
          @click="onClick(RECHARGE_PURCHASE_TYPES.SUBSCRIPTION)"
        />
        <input
          id="option-subscription"
          tabindex="-1"
          type="radio"
          value="subscription"
          name="subscription"
          :disabled="!selectedVariant"
          :checked="purchaseType === RECHARGE_PURCHASE_TYPES.SUBSCRIPTION"
          @click="onClick(RECHARGE_PURCHASE_TYPES.SUBSCRIPTION)"
        />
      </span>
      <label
        v-if="discountPercentage > 0"
        tabindex="1"
        for="option-subscription"
        v-html="translateAndSaveText()"
      />
      <label v-else tabindex="1" for="option-subscription">
        {{ translations.subscribeText }}
      </label>
    </div>
  </div>
</template>

<script>
import { RECHARGE_PURCHASE_TYPES } from '../ProductCard/const';

export default {
  name: 'PurchaseTypeSelector',

  model: {
    prop: 'purchaseType',
    event: 'change'
  },
  props: {
    purchaseType: {
      type: String,
      required: true
    },
    discountPercentage: {
      type: Number
    },
    translations: {
      type: Object,
      required: true
    },
    selectedVariant: {
      type: Object
    }
  },
  created() {
    this.RECHARGE_PURCHASE_TYPES = RECHARGE_PURCHASE_TYPES;
  },
  methods: {
    onClick(value) {
      if (this.selected !== value) {
        this.$emit('purchaseTypeUpdateEmit', value);
      }
    },
    translateAndSaveText() {
      return `${this.translations.subscribeAndSaveText} ${this.discountPercentage}%`;
    }
  }
};
</script>
